;(function () {
  'use strict'

  angular
    .module('contrast.shared.groups')
    .factory(
      'sharedGroupService',
      function sharedGroupServiceFactory(ROLES_LIST, GROUP_TYPE) {
        return {
          formatOrganizationGroups: function formatOrganizationGroups(groups) {
            var parts, role, roleFound
            _.each(groups, function (group) {
              group.group_type = group.readonly
                ? GROUP_TYPE.DEFAULT
                : GROUP_TYPE.CUSTOM
              if (group.readonly) {
                parts = group.name.split(' ')
                role = parts[parts.length - 2]
                roleFound = _.find(ROLES_LIST, function (roleList) {
                  return roleList.value == role
                })

                // Hopefully we don't encounter this case but if we
                // do then we can at least keep the app from crashing
                if (roleFound === undefined) {
                  roleFound = {
                    label: role,
                    value: role
                  }
                }

                angular.extend(group, {
                  name: roleFound.label
                })
              }
            })
          }
        }
      }
    )
})()
